/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function MapPinJuicyIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="map-pin-juicy"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M6.591 15.728C3.603 12.741 3.603 7.897 6.591 4.909C9.578 1.922 14.422 1.922 17.409 4.909C20.397 7.897 20.397 12.741 17.409 15.728L12 21.137L6.591 15.728Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <circle cx={12} cy={10.319} r={3.005} stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
    </svg>
  )
}
